"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Faq = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var QuestionAndAnswersContainer_1 = __importDefault(require("../../containers/QuestionAndAnswersContainer"));
var Layout_1 = __importDefault(require("../Layout"));
var arches_png_1 = __importDefault(require("../../static/img/png/arches.png"));
var styles_1 = require("./styles");
function Faq(_a) {
    (0, react_1.useEffect)(function () {
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }, []);
    return ((0, jsx_runtime_1.jsxs)(Layout_1.default, { children: [(0, jsx_runtime_1.jsxs)(styles_1.Container, { children: [(0, jsx_runtime_1.jsx)(styles_1.Title, { children: "Preguntas frecuentes" }), (0, jsx_runtime_1.jsx)(QuestionAndAnswersContainer_1.default, {})] }), (0, jsx_runtime_1.jsx)(styles_1.Img, { src: arches_png_1.default })] }));
}
exports.Faq = Faq;
